import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {ProductKind} from '../models/product-kind';
import {ProductKindService} from '../services/product-kind.service';

@Injectable()

/**
 * ProductKindResolver resolves request to get the available product kinds
 */
export class ProductKindResolver implements Resolve<ProductKind[]>
{
    /**
     * GroupRightsResolver constructor
     *
     * @param {GroupRightService} groupRightService
     */
    constructor(private productKindService: ProductKindService)
    {
    
    }

    /**
	 * Provides data to a route
	 *
	 * @returns {Observable<ProductKind[]>}
	 */
	resolve(): Observable<ProductKind[]>
	{
		return this.productKindService.getProductKinds();
	}
}



// WEBPACK FOOTER //
// ./src/app/resolvers/product-kind.resolver.ts